export const VEHICLE_DATA_SOURCE_FB = 1
export const VEHICLE_DATA_SOURCE_VD = 2
export const VEHICLE_DATA_SOURCE_WF = 3